"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createImageAvatarStyle;

function createImageAvatarStyle(_ref) {
  var avatarSize = _ref.avatarSize;
  return {
    height: avatarSize,
    overflow: 'hidden',
    width: avatarSize
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVJbWFnZUF2YXRhclN0eWxlIiwiYXZhdGFyU2l6ZSIsImhlaWdodCIsIm92ZXJmbG93Iiwid2lkdGgiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvSW1hZ2VBdmF0YXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RyaWN0U3R5bGVPcHRpb25zIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlSW1hZ2VBdmF0YXJTdHlsZSh7IGF2YXRhclNpemUgfTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgaGVpZ2h0OiBhdmF0YXJTaXplLFxuICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICB3aWR0aDogYXZhdGFyU2l6ZVxuICB9O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRWUsU0FBU0Esc0JBQVQsT0FBb0U7RUFBQSxJQUFsQ0MsVUFBa0MsUUFBbENBLFVBQWtDO0VBQ2pGLE9BQU87SUFDTEMsTUFBTSxFQUFFRCxVQURIO0lBRUxFLFFBQVEsRUFBRSxRQUZMO0lBR0xDLEtBQUssRUFBRUg7RUFIRixDQUFQO0FBS0QifQ==